const RustCrabIcon = ({
  fill = undefined,
  filled = false,
  size = undefined,
  height = undefined,
  width = undefined,
  label = "RustCrabIcon",
  ...props
}) => {
  return (
    <svg
      fill={filled ? fill : "none"}
      {...props}
      viewBox="0 0 323 255"
      focusable="false"
      stroke="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g clipPath="url(#clip0_610_298)">
        <path
          fill="#FDF9ED"
          d="M37.223 139.265c.044.045.09.091 0 0zM289.391 148.958c-.143-.884-.277-1.767-.431-2.642l10.066-11.338a4.682 4.682 0 001.019-4.277c-.39-1.499-1.505-2.674-2.942-3.112l-14.161-4.227c-.415-1.21-.872-2.415-1.321-3.598l7.782-13.16a4.635 4.635 0 00.196-4.389c-.665-1.391-1.972-2.317-3.478-2.442l-14.736-1.265a110.893 110.893 0 00-1.963-3.213l5.205-14.494c.524-1.477.291-3.108-.626-4.339-.918-1.22-2.38-1.864-3.873-1.684l-14.724 1.758a138.184 138.184 0 00-2.522-2.767l2.395-15.242c.25-1.541-.294-3.1-1.429-4.115a4.194 4.194 0 00-4.125-.87l-14.108 4.706a131.448 131.448 0 00-3.023-2.214l-.501-15.366c-.05-1.558-.873-2.979-2.181-3.734a4.152 4.152 0 00-4.211-.003l-12.986 7.463a134.852 134.852 0 00-3.396-1.555l-3.366-14.932c-.347-1.523-1.416-2.743-2.838-3.22-1.423-.477-2.984-.155-4.135.853l-11.38 9.967a113.52 113.52 0 00-3.587-.813l-6.123-13.97c-.622-1.417-1.903-2.39-3.392-2.573-1.489-.183-2.967.452-3.913 1.676l-9.331 12.072c-1.225-.039-2.46-.07-3.688-.08l-8.63-12.424a4.24 4.24 0 00-3.816-1.829c-1.507.128-2.838 1.042-3.533 2.438l-6.888 13.672c-1.235.212-2.452.445-3.671.688l-10.785-10.381a4.17 4.17 0 00-4.097-1.017c-1.443.427-2.594 1.595-3.01 3.096l-4.213 14.787c-1.164.451-2.321.934-3.469 1.418l-12.55-7.98a4.147 4.147 0 00-4.213-.154c-1.347.711-2.252 2.091-2.383 3.647l-1.363 15.368c-1.05.677-2.082 1.367-3.116 2.076l-13.861-5.269a4.207 4.207 0 00-4.166.698c-1.197.971-1.818 2.497-1.657 4.058l1.534 15.321c-.902.867-1.797 1.754-2.672 2.644L46.401 70.34a4.312 4.312 0 00-3.966 1.528c-.992 1.188-1.312 2.811-.871 4.306l4.367 14.652c-.723 1.05-1.457 2.098-2.153 3.17l-14.762.677c-1.5.068-2.866.938-3.608 2.307a4.685 4.685 0 00-.046 4.397l7.035 13.438c-.097.21-.183.421-.27.632l-5.307 4.416 10.444 19.397s114.4 70.83 233.638 29.645c13.137-.725 18.53-19.951 18.53-19.951l-.041.005z"
        ></path>
        <path
          fill="#65498B"
          d="M183.383 125.716s15.223-13.042 26.839 3.295c0 0 8.135 20.888-3.609 29.39 0 0-18.935 11.599-26.838-3.296 0 0-10.18-12.191 3.608-29.389z"
        ></path>
        <path
          fill="#FDF9ED"
          d="M198.256 133.084c-.703 5.727-4.647 9.948-8.805 9.437-4.159-.51-6.965-5.56-6.262-11.287.704-5.727 4.647-9.948 8.806-9.437 4.159.511 6.965 5.56 6.261 11.287z"
        ></path>
        <path
          fill="#65498B"
          d="M123.975 114.351s24.269-7.367 27.759 16.153c0 0 3.324 27.329-22.347 25.688 0 0-31.727-10.253-5.42-41.852l.008.011z"
        ></path>
        <path
          fill="#FDF9ED"
          d="M134.331 125.608c-.724 5.896-4.786 10.263-9.084 9.735-4.298-.527-7.184-5.738-6.459-11.644.725-5.905 4.786-10.263 9.084-9.735 4.298.528 7.184 5.738 6.459 11.644zM40.772 142.854c3.483-3.098 11.424-6.395 11.498-11.676.125-9.465-6.78-17.234-15.439-17.361a14.26 14.26 0 00-6.068 1.25c-.125-.045-.25-.091-.377-.127 0 0-30.623 10.627-17.64 41.016-.017 1.449 27.517 47.417 36.305 51.74 5.748 2.832-1.146-36.532-8.27-64.831l-.01-.011zM275.566 170.393c-3.168-3.411-12.165-7.267-11.729-12.543.775-9.436 8.394-16.51 17.023-15.803 2.135.171 4.142.811 5.922 1.815.126-.035.261-.069.385-.094 0 0 29.464 13.502 13.651 42.511-.117 1.446-31.91 44.573-41.07 48.033-5.991 2.267 6.035-36.436 15.829-63.928l-.011.009zM63.01 145.051s-5.085 38.215 31.365 51.355l9.749-14.742s-27.489-.705-25.442-34.689l-15.672-1.924zM254.027 168s-4.311 38.311-42.858 42.242l-5.893-16.662s26.843 5.966 33.078-27.504L254.027 168z"
        ></path>
        <path
          fill="#FDF9ED"
          d="M222.148 203.702c-3.973-14.331-21.511-21.985-39.189-17.093-15.561 4.305-26.013 16.895-25.592 29.632 11.714 1.257 24.344 2.031 36.769 1.764 0 0-8.625 10.759-20.472 19.611 6.901 2.711 15.27 3.225 23.676.902 17.678-4.892 28.791-20.484 24.818-34.815l-.01-.001zM115.736 207.713s15.135 3.924 36.103 7.022c3.472-13.014-4.842-28.261-20.176-35.644-16.942-8.156-36.045-3.64-42.66 10.106-6.613 13.736 1.756 31.489 18.697 39.654 7.516 3.613 15.448 4.738 22.53 3.673-9.033-11.436-14.495-24.801-14.495-24.801l.001-.01z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_610_298">
          <path
            fill="#fff"
            d="M0 0H297.56V219.47H0z"
            transform="rotate(7 13.373 218.652)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default RustCrabIcon;
